import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsUtils from '@netsapiens/netsapiens-js/dist/utils';

import './styles.css';
import template from './template.html';
import { getConfig } from '../../core/configs';

function controller(
  $mdDialog,
  $ngRedux,
  $translate,
) {
  const self = this;
  let unsubscribe = null;

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect((state) => ({
      apiHash: getConfig(state, 'apiHash'),
      pathname: getConfig(state, 'pathname'),
      screenSize: state.screenSize,
      wpName: getConfig(state, 'wpName'),
    }))(this);
    self.spinner = false;
    self.forgotUsername = '';
  };

  this.$onDestroy = () => {
    unsubscribe();
  };

  this.send = (form) => {
    self.formMessage = '';

    if (form.$valid) {
      self.spinner = true;

      const decodedApiHash = nsUtils.encoding.base64Decode(self.apiHash);
      const client_id = decodedApiHash.split(':');

      nsApi.post({
        object: 'email',
        action: 'create',
        subject: `Your Login ${self.wpName} Recovery`,
        template: 'forgotten_username_email.php',
        app_uri: `${global.location.origin}${self.pathname}`,
        recipient: form.email.$viewValue,
        user: form.ext.$viewValue || null,
        client_id,
      }).then((res) => {
        if (res.sent) {
          $mdDialog.show($mdDialog.alert()
            .clickOutsideToClose(true)
            .textContent($translate.instant('AN_EMAIL_HAS_BEEN_SENT_TO_THE_SPECIFIED_ADDRESS.'))
            .ok('OK'));
        } else {
          $mdDialog.show($mdDialog.alert()
            .clickOutsideToClose(true)
            .textContent(
              'There was a problem retrieving your account. Please contact your administrator.',
            )
            .ok('OK'));
        }

        self.spinner = false;
      }).catch(() => {
        $mdDialog.show($mdDialog.alert()
          .clickOutsideToClose(true)
          .textContent(
            'There was a problem retrieving your account. Please contact your administrator.',
          )
          .ok('OK'));
        self.spinner = false;
      });
    }
  };
}

controller.$inject = [
  '$mdDialog',
  '$ngRedux',
  '$translate',
];

export default {
  template,
  controller,
};
